module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mounted) ? _c('div', {
    staticClass: "component-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-placeholder",
    attrs: {
      "data-toggle": 'dropdown-' + _vm._uid
    }
  }, [_vm._t("placeholder", [_c('i', {
    class: _vm.icon
  })])], 2), _c('div', {
    directives: [{
      name: "f-dropdown",
      rawName: "v-f-dropdown"
    }],
    staticClass: "dropdown-pane",
    class: _vm.position,
    attrs: {
      "data-close-on-click": "true",
      "id": 'dropdown-' + _vm._uid,
      "data-auto-focus": "true",
      "data-dropdown": ""
    }
  }, [_vm._t("default")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c63a9648!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Dropdown.vue
// module id = 2692
// module chunks = 1